import { render, staticRenderFns } from "./OpportunityHeader.vue?vue&type=template&id=856ab574"
import script from "./OpportunityHeader.vue?vue&type=script&lang=js"
export * from "./OpportunityHeader.vue?vue&type=script&lang=js"
import style0 from "./OpportunityHeader.vue?vue&type=style&index=0&id=856ab574&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports